import type { FormKitNode } from '@formkit/core'

export type AiFillCollectionOptions = {
  collectionKey?: string | null
  collectionListName?: string | null
  childIdField?: string | null
}

export const encodeCollectionField = (
  collectionKey: string,
  childId: number,
  field: string,
) => `${collectionKey}:${childId}:${field}`

/** `image:42:name` → `name`. Flat field names are returned unchanged. */
export const decodeCollectionField = (name: string) => {
  const parts = name.split(':')
  return parts.length === 3 ? parts[2] : name
}

export const resolveCollectionChildId = (
  node: FormKitNode | null | undefined,
  options: AiFillCollectionOptions,
): number | null => {
  const listName = options.collectionListName
  if (!options.collectionKey || !listName) return null

  let current: FormKitNode | null | undefined = node
  while (current && String(current.name) !== listName) {
    current = current.parent
  }
  const holder = current?.parent
  if (!holder) return null

  const idField = options.childIdField || 'id'
  for (const values of [holder.context?.value as any, holder.value as any]) {
    const raw = values?.[idField]
    const id = typeof raw === 'number' ? raw : raw ? Number(raw) : NaN
    if (Number.isInteger(id) && id > 0) return id
  }
  return null
}

export const useCollectionChildId = (
  node: FormKitNode,
  options: Ref<AiFillCollectionOptions>,
) => {
  const treeVersion = ref(0)
  onMounted(() => nextTick(() => treeVersion.value++))
  return computed(() => {
    treeVersion.value
    return resolveCollectionChildId(node, options.value)
  })
}
